import React from "react";
import ReactDOM from "react-dom";

import "./setup/index.css";

import App from "./routing/App";

ReactDOM.render(<App />, document.getElementById("root"));
